var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32812 6.0026H8.66146V4.66927H7.32812V6.0026ZM7.99479 13.3359C5.05479 13.3359 2.66146 10.9426 2.66146 8.0026C2.66146 5.0626 5.05479 2.66927 7.99479 2.66927C10.9348 2.66927 13.3281 5.0626 13.3281 8.0026C13.3281 10.9426 10.9348 13.3359 7.99479 13.3359ZM7.99479 1.33594C7.11931 1.33594 6.25241 1.50838 5.44357 1.84341C4.63473 2.17844 3.8998 2.6695 3.28075 3.28856C2.0305 4.5388 1.32813 6.23449 1.32812 8.0026C1.32813 9.77071 2.0305 11.4664 3.28075 12.7166C3.8998 13.3357 4.63473 13.8268 5.44357 14.1618C6.25241 14.4968 7.11931 14.6693 7.99479 14.6693C9.7629 14.6693 11.4586 13.9669 12.7088 12.7166C13.9591 11.4664 14.6615 9.77071 14.6615 8.0026C14.6615 7.12712 14.489 6.26022 14.154 5.45138C13.819 4.64254 13.3279 3.90762 12.7088 3.28856C12.0898 2.6695 11.3549 2.17844 10.546 1.84341C9.73718 1.50838 8.87027 1.33594 7.99479 1.33594ZM7.32812 11.3359H8.66146V7.33594H7.32812V11.3359Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationOutline);
export default __webpack_public_path__ + "static/media/information-outline.4a5e6944.svg";
export { ForwardRef as ReactComponent };